import FAVICONS from 'shared/favicons';
import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';
import GROUP_DETAIL_PAGE_CHILDREN from './post_detail/postDetailPageChildren';

const GROUP_PAGE_CHILDREN = [
    {
        name: 'groupDetailPage-default',
        component: () => import(/* webpackChunkName: "groupPage" */ './GroupPageDefault'),
        path: '',
        meta: {name: 'default'}
    },
    {
        name: 'groupDetailPage-story',
        component: () => import(/* webpackChunkName: "groupPage" */ './GroupPageStory'),
        path: 'detail',
        meta: {name: 'story'}
    },
    {
        name: 'groupDetailPage-activity',
        component: () => import(/* webpackChunkName: "groupPage" */ './GroupPageActivity'),
        path: 'activity',
        meta: {name: 'activity'}
    },
    {
        name: 'groupDetailPage-events',
        component: () => import(/* webpackChunkName: "groupPage" */ './GroupPageEvents'),
        path: 'events',
        meta: {name: 'events'}
    },
    {
        name: 'groupDetailPage-posts',
        component: () => import(/* webpackChunkName: "groupPage" */ './GroupPagePosts'),
        path: 'posts',
        meta: {name: 'posts'}
    },
    {
        name: 'groupDetailPage-chats',
        component: () => import(/* webpackChunkName: "groupPage" */ './GroupPageChats'),
        path: 'chats',
        meta: {name: 'chats'}
    },
    {
        name: 'groupDetailPage-shared-stories',
        component: () => import(/* webpackChunkName: "groupPage" */ './sharing_lists/GroupPageSharedListStories'),
        path: 'shared-stories',
        meta: {name: 'shared-stories'}
    },
    {
        name: 'groupDetailPage-shared-wiki',
        component: () => import(/* webpackChunkName: "groupPage" */ './sharing_lists/GroupPageSharedListWiki'),
        path: 'shared-wikis',
        meta: {name: 'shared-wiki'}
    },
    {
        name: 'groupDetailPage-shared-media',
        component: () => import(/* webpackChunkName: "groupPage" */ './sharing_lists/GroupPageSharedListMedia'),
        path: 'shared-media',
        meta: {name: 'shared-media'}
    },
    {
        name: 'groupDetailPage-members',
        component: () => import(/* webpackChunkName: "groupPage" */ './GroupPageMembers'),
        path: 'members',
        meta: {name: 'members'}
    },
];

export default defineSection({
    head: sectionHead({icon: FAVICONS.group, titleTemplate: '%s - Group - Multi Me'}),
    routes: [
        {
            path: '/group/post/:postId(\\d+)/',
            component: () => import(/* webpackChunkName: "groupPage" */ './post_detail/GroupPostDetailPage'),
            children: GROUP_DETAIL_PAGE_CHILDREN,
            props: true,
            name: 'groupPostDetailPage',
        },
        {
            path: '/group/:groupSlug/',
            component: () => import(/* webpackChunkName: "groupPage" */ './GroupPage'),
            children: GROUP_PAGE_CHILDREN,
            props: true,
            name: 'groupDetailPage',
        },
    ]
});
